import { WidgetHelper } from './Widget';
import { WidgetType } from './widgetType';
export const LabeledGraphicHelper = {
    create: (id, trackingIdentifier, markers, properties, assetId) => {
        const data = {
            assetId: assetId,
            markers: markers,
        };
        return WidgetHelper.buildWidget(id, trackingIdentifier, data, properties, WidgetType.labeledGraphic);
    },
    isLabeledGraphic: (widget) => {
        return widget.value.type === WidgetType.labeledGraphic;
    },
    isLabeledGraphicServerData: (widget) => {
        return widget.type === WidgetType.labeledGraphic;
    },
    makeDefaultProperties: () => {
        return { displayDelayInSeconds: 0, isRequired: false };
    },
};
